<div class="store-demographic-profile-panel-container container" [ngClass]="{'default-padding': !hasStandardLicense}">
  <div class="header-container" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px">
    <h1 class="mat-h1 color-primary text-small-caps no-bottom-margin">{{ storeAnalysys ? 'Demographic Summary' : 'Demographic Profile' }}</h1>
    <mtn-what-is-this [text]="PANEL_DESCRIPTION"></mtn-what-is-this>
    <div fxFlex></div>
    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
      <div class="region-container" fxLayout="row" fxLayoutGap="5px" [ngSwitch]="form.get('region').value">
        <span class="color-muted">{{'CURRENT_REGION' | translate}}</span>
        <span *ngSwitchCase="RegionType.MARKET_AREA">{{'MARKET_AREA' | translate}}</span>
        <span *ngSwitchCase="RegionType.DRIVE_TIME">{{ 'DRIVE_TIME' | translate:{ value: form.get('driveTimeMinutes').value } }}</span>
        <span *ngSwitchCase="RegionType.RING">{{form.get('ringMiles').value}}-mile Ring</span>
      </div>
      @if(!storeAnalysys){
        <mtn-icon-button matTooltip="{{'OPTIONS' | translate}}"   [matMenuTriggerFor]="optionsMenu"
                         mtnAnalyticsEventTrigger [analyticsEventName]="AnalyticsEventType.TOGGLE_MENU"
                         [analyticsEventParameters]="{'target': 'demographic-profile-options-button'}">
          <fa-icon icon="cog"></fa-icon>
        </mtn-icon-button>
        <mtn-icon-button color="accent" (click)="openDetailsWizard()" matTooltip="{{'VIEW_DETAILS' | translate}}"
                       mtnAnalyticsEventTrigger [analyticsEventName]="AnalyticsEventType.CLICK_BUTTON"
                       [analyticsEventParameters]="{'target': 'demographic-profile-view-all-button'}">
        <fa-icon icon="ellipsis-h"></fa-icon>
      </mtn-icon-button>
      }
      @else {
        <mtn-icon-button-pop-up matTooltip="{{'OPTIONS' | translate}}"   [matMenuTriggerFor]="optionsMenu"
        mtnAnalyticsEventTrigger [analyticsEventName]="AnalyticsEventType.TOGGLE_MENU"
        [analyticsEventParameters]="{'target': 'demographic-profile-options-button'}">
        <fa-icon icon="cog"></fa-icon> </mtn-icon-button-pop-up>

        <mtn-icon-button-pop-up color="accent" (click)="openDetailsWizard()" matTooltip="{{'VIEW_DETAILS' | translate }}"
        mtnAnalyticsEventTrigger [analyticsEventName]="AnalyticsEventType.CLICK_BUTTON"
        [analyticsEventParameters]="{'target': 'demographic-profile-view-all-button'}">
        <fa-icon icon="ellipsis-h"></fa-icon> </mtn-icon-button-pop-up>
      }
    </div>
  </div>
  <hr style="margin-bottom: 30px;"/>
  <div *ngIf="!isLoading" class="content-container">
    <div class="presentation-container container"[ngClass]="storeAnalysys ? 'center-align' : '' "  fxLayout="row wrap" fxLayoutGap="15px" *ngIf="demographics">
      <div fxLayout="row wrap" fxLayoutGap="15px">
        <div class="ethnicity-container">
          <h2 class="mat-h2 text-small-caps text-center no-bottom-margin">{{'ETHNICITY' | translate}}</h2>
          <hr/>
          <div class="pie-chart-container">
          <mtn-pie-chart-legend [datasets]="ethnicityDataSet"
                                [labels]="ethnicityLabels"></mtn-pie-chart-legend>
          </div>
        </div>
        <div class="demographic-card-container">
          <h2 class="mat-h2 text-small-caps text-center no-bottom-margin">{{'POPULATION' | translate }}</h2>
          <hr/>
          <div class="card-container" fxLayout="row" fxLayoutGap="10px">

            <mtn-demographic-card icon="history" color="#3d7cc9" label="Historical 2yr Growth"
                                  [value]="pop2yrChangeText"
                                  matTooltip="{{'POPULATION_GROWTH' | translate }}"></mtn-demographic-card>
            <mtn-demographic-card icon="users" color="#3d7cc9" label="Total Population"
                                  [value]="demographics.populationEstimate?.toLocaleString()"
                                  matTooltip="{{'ESTIMATED_POPULATION' | translate}}"></mtn-demographic-card>
            <mtn-demographic-card icon="chart-line" color="#3d7cc9" label="Projected 5yr Growth"
                                  [value]="pop5yrProjectionText"
                                  matTooltip="{{'PROJECTED_GROWTH' | translate}}"></mtn-demographic-card>
          </div>
        </div>
      </div>
      <div fxLayout="row wrap" fxLayoutGap="15px">
        <div class="demographic-card-container">
          <h2 class="mat-h2 text-small-caps text-center no-bottom-margin">{{'PEOPLE' | translate}}</h2>
          <hr/>
          <div class="card-container" fxLayout="row" fxLayoutGap="10px">
            <mtn-demographic-card [icon]="['far', 'clock']" color="#0033a1" label="Average Age"
                                  [value]="demographics.ageAverage?.toFixed(1)"
                                  matTooltip="{{'AVERAGE_AGE' | translate}}"></mtn-demographic-card>
            <mtn-demographic-card icon="graduation-cap" color="#0033a1" label="College Educated"
                                  [value]="round(demographics.educationCollegeOrDegree * 100, 2) + '%'"
                                  matTooltip="{{'PERCENTAGE_OF_THE_POPULATION' | translate}}"></mtn-demographic-card>
            <mtn-demographic-card icon="home" color="#0033a1" label="Household Size"
                                  [value]="demographics.householdsPersonsPer?.toFixed(1)"
                                  matTooltip="{{'AVERAGE_PERSONS_PER_HOUSEHOLD' | translate}}"></mtn-demographic-card>
          </div>
        </div>
        <div class="demographic-card-container">
          <h2 class="mat-h2 text-small-caps text-center no-bottom-margin">{{'INCOME' | translate}}</h2>
          <hr/>
          <div class="card-container" fxLayout="row" fxLayoutGap="10px">
            <mtn-demographic-card icon="dollar-sign" secondaryIcon="home" color="#68478d" label="Average Income"
                                  [value]="incomeAverage" matTooltip="{{'AVERAGE_HOUSEHOLD_INCOME' | translate}}"></mtn-demographic-card>
            <mtn-demographic-card icon="dollar-sign" secondaryIcon="home" color="#68478d" label="Median Income"
                                  [value]="incomeMedian" matTooltip="{{'MEDIAN_HOUSEHOLD_INCOME' | translate}}"></mtn-demographic-card>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="large-area-warning" *ngIf="(isLoading && isLargeArea) || (isLoading && storeAnalysys)" fxLayoutAlign="center center">
    <mtn-simple-panel color="blue">
      <div fxLayout="row" fxLayoutAlign="start center" style="position: fixed;" fxLayoutGap="15px">
        <fa-icon icon="info-circle" size="2x"></fa-icon>
        <div>{{'LOADING_MESSAGE' | translate}}
        </div>
      </div>
    </mtn-simple-panel>
  </div>
  <br/>
  <mtn-partner-attribution-container>
    <mtn-partner-attribution [partnerType]="PartnerType.SYNERGOS"></mtn-partner-attribution>
  </mtn-partner-attribution-container>
  <mtn-spinner [on]="isLoading" [size]="SpinnerSize.LARGE"></mtn-spinner>
  <mtn-restricted-license-overlay *ngIf="!hasStandardLicense"></mtn-restricted-license-overlay>

  <div *ngIf="!isLoading &&  !demographics && storeAnalysys" class="no-data"> {{'NO_DATA' | translate}}</div>
</div>

<mat-menu class="right-aligned-menu" #optionsMenu="matMenu">
  <form class="default-padding" [formGroup]="form" fxLayout="column" (click)="stopPropagation($event)">
    <mtn-region-field [form]="form" [isMarketAreaAvailable]="!!marketArea"></mtn-region-field>
    <mtn-drive-time-minutes-field [form]="form"
                                  *ngIf="form.get('region').value === RegionType.DRIVE_TIME"></mtn-drive-time-minutes-field>
    <mtn-ring-miles-field [form]="form" *ngIf="form.get('region').value === RegionType.RING"></mtn-ring-miles-field>

  </form>
</mat-menu>
